export let baseURL = ''
import {uuid} from '@/assets/javascript/soleid'

export const headers = {
    "X-Agent": 'web',
    "X-User-Token": localStorage.MklUserToken ? localStorage.MklUserToken : '',
    // "X-Device-Id": localStorage.soleId ? localStorage.soleId : '',
    "X-Language": 'cn',
    "X-Timestamp": undefined
};

// 设置接口地址开始
// let origin = window.location.origin;
// if (origin === "https://www.macklin.cn" || origin === "http://www.macklin.cn") {
    // baseURL = 'https://api.macklin.cn';
    // baseURL = 'http://api.chem-seek.cn:61668'
    baseURL = 'https://api.x-labseek.com'
    //  baseURL = 'http://apidev.meryer.macklin.com.cn'
// } else {
//    baseURL = 'http://msmsapi.macklin.com.cn';
// }
// 设置接口地址结束

// 设置 X-Device-Id 值开始
let soleId = uuid(16, 16)
if (!localStorage.soleId) {
    localStorage.soleId = soleId
}
// 设置 X-Device-Id 值结束
